module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      John Murray\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v(" "), _c('B', [_vm._v("John Murray")]), _vm._v(" (1898–1975) spent most of his distinguished career teaching systematic theology at Westminster Theological Seminary in Philadelphia. His notable books include "), _c('I', [_vm._v("Principles of Conduct")]), _vm._v(" and "), _c('I', [_vm._v("Redemption Accomplished and Applied")]), _vm._v(".")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/33r8MP/tc-custom/9781467450584.jpg?1734042219857",
      "alt": "This image is the cover for the book The Epistle to the Romans, Eerdmans Classic Biblical Commentaries (ECBC)"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("The Epistle to the Romans, Eerdmans Classic Biblical Commentaries (ECBC)\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Careful scholarship and spiritual insight characterize this enduring commentary by John Murray on Romans, first published in 1959 as part of the New International Commentary on the New Testament series. ")]), _c('p', [_vm._v("After a brief introduction to the authorship, occasion, setting, and message of the epistle, Murray provides a verse-by-verse exposition of Romans that is deeply penetrating in its elucidation of the text. In ten appendices he gives special attention to select themes and scholarly debates—the meaning of justification, Isaiah 53:11 in relation to Romans, Karl Barth on Romans 5, the interpretation of the “weak brother” in Romans 14, and more. ")]), _c('p', [_vm._v("Murray’s classic commentary on Romans in this new edition will continue to be valuable to pastors, students, and scholars everywhere. ")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    William B. Eerdmans Publishing Company\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0